import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, normalizeStyle as _normalizeStyle, vModelText as _vModelText, withDirectives as _withDirectives, withKeys as _withKeys, vModelCheckbox as _vModelCheckbox, vShow as _vShow, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "min-h-screen w-full" }
const _hoisted_2 = { class: "md:hidden mb-4 sticky top-2 z-40 px-4" }
const _hoisted_3 = { class: "w-full px-4 py-6" }
const _hoisted_4 = { class: "flex flex-col md:flex-row gap-4" }
const _hoisted_5 = { class: "md:hidden flex justify-between items-center mb-4 pb-2 border-b px-4 pt-4" }
const _hoisted_6 = ["onClick"]
const _hoisted_7 = { class: "text-sm font-medium text-gray-900" }
const _hoisted_8 = {
  key: 0,
  class: "text-xs text-gray-500 ml-1"
}
const _hoisted_9 = {
  key: 1,
  class: "text-xs text-[#157813] ml-1"
}
const _hoisted_10 = { class: "text-gray-500 text-sm" }
const _hoisted_11 = { class: "mt-2 space-y-2" }
const _hoisted_12 = { class: "flex justify-between items-center mb-2" }
const _hoisted_13 = ["onClick"]
const _hoisted_14 = { key: 0 }
const _hoisted_15 = { class: "space-y-4 px-2" }
const _hoisted_16 = {
  key: 0,
  class: "flex justify-center items-center py-4"
}
const _hoisted_17 = { class: "text-center" }
const _hoisted_18 = { class: "text-xs text-gray-600" }
const _hoisted_19 = { class: "grid grid-cols-2 gap-3" }
const _hoisted_20 = ["min", "max", "value"]
const _hoisted_21 = ["min", "max", "value"]
const _hoisted_22 = { class: "bg-gray-50 rounded p-2 text-center" }
const _hoisted_23 = { class: "text-sm text-gray-700" }
const _hoisted_24 = { class: "font-medium text-[#157813]" }
const _hoisted_25 = { class: "font-medium text-[#157813]" }
const _hoisted_26 = { class: "space-y-2" }
const _hoisted_27 = { class: "slider-container" }
const _hoisted_28 = ["min", "max", "value"]
const _hoisted_29 = ["min", "max", "value"]
const _hoisted_30 = { class: "flex justify-between text-xs text-gray-500" }
const _hoisted_31 = { key: 1 }
const _hoisted_32 = { class: "relative" }
const _hoisted_33 = ["onClick"]
const _hoisted_34 = { class: "flex flex-wrap gap-1 flex-1" }
const _hoisted_35 = ["onClick"]
const _hoisted_36 = ["onClick"]
const _hoisted_37 = ["onInput", "onFocus", "onUpdate:modelValue"]
const _hoisted_38 = { class: "absolute z-10 w-full mt-1 bg-white border border-gray-300 rounded-md shadow-lg max-h-60 overflow-y-auto dropdown-container" }
const _hoisted_39 = { class: "relative mb-2" }
const _hoisted_40 = ["onUpdate:modelValue", "onKeydown"]
const _hoisted_41 = { class: "space-y-1" }
const _hoisted_42 = {
  key: 0,
  class: "text-gray-500 text-xs italic px-2 py-1"
}
const _hoisted_43 = ["value", "onUpdate:modelValue", "onChange"]
const _hoisted_44 = { class: "text-sm text-gray-700" }
const _hoisted_45 = { class: "flex-1 min-w-0" }
const _hoisted_46 = {
  key: 0,
  class: "py-8"
}
const _hoisted_47 = { key: 1 }
const _hoisted_48 = { class: "text-sm text-gray-600 mb-4 px-1" }
const _hoisted_49 = { class: "overflow-x-auto" }
const _hoisted_50 = {
  key: 2,
  class: "mt-6"
}
const _hoisted_51 = {
  key: 3,
  class: "text-center py-12 text-gray-500"
}


import HeroSection from "@/components/HeroSection.vue";
import LoadingIndicator from "@/components/LoadingIndicator.vue";
import Pagination from "@/components/Pagination.vue";
import QueryTable from "@/components/QueryTable.vue";
import SuggestionDropdown from "@/components/SuggestionDropdown.vue";
import type { Query } from "@/models/Query";
import { mapQueryType, transformQueries } from "@/models/Query";
import rawQueries from "@/queries.json";
import { clearFiltersFromStorage, loadFiltersFromStorage, saveFiltersToStorage, type FilterState } from "@/utils/filterPersistence";
import { computed, onMounted, onUnmounted, ref, watch } from "vue";
import { useRouter } from "vue-router";

interface OpenSections {
  features: boolean;
  author: boolean;
  indicationEnrichments: boolean;
  medicationEnrichments: boolean;
  tableNames: boolean;
  columnNames: boolean;
  extraction: boolean;
  queryType: boolean;
}
type OpenSectionKey = keyof OpenSections;

const __default__ = {
  name: "YourComponentName",
  components: {
    HeroSection,
    QueryTable,
    LoadingIndicator,
    Pagination,
    SuggestionDropdown
  },
};

export default /*@__PURE__*/_defineComponent({
  ...__default__,
  setup(__props, { expose: __expose }) {

const router = useRouter();

const queries = ref<Query[]>(transformQueries(rawQueries as any[]));
const filteredQueries = ref<Query[]>([]);
const displayedQueries = ref<Query[]>([]);
const itemsPerPage = 20;
const currentPage = ref(1);
const showUniqueQueries = ref(true);

// Filter state
const showMobileFilters = ref(false);
const isLoading = ref(false);
const filtersLoading = ref(false);
const filters = ref({
  features: [] as string[],
  indicationEnrichments: [] as string[],
  medicationEnrichments: [] as string[],
  tableNames: [] as string[],
  columnNames: [] as string[],
  author: [] as string[],
  extraction: [0, 0] as number[],
  queryType: [] as string[],
});

// Separate tracking for individual original query types
const selectedOriginalTypes = ref<string[]>([]);

const openSections = ref<OpenSections>({
  features: false,
  author: false,
  indicationEnrichments: false,
  medicationEnrichments: false,
  tableNames: false,
  columnNames: false,
  extraction: false,
  queryType: false,
});

const dropdownStates = ref<{ [key: string]: boolean }>({});
const dropdownSearch = ref<{ [key: string]: string }>({});
const heroSearchTerm = ref("");

const filterGroups = {
  queryType: "Query Types",
  features: "Features",
  author: "Authors",
  tableNames: "Table Names",
  columnNames: "Column Names",
  indicationEnrichments: "Indication Enrichments",
  medicationEnrichments: "Medication Enrichments",
  extraction: "Run Count",
};

const tableHeaders = [
  { key: "id", label: "Query ID" },
  { key: "neuronId", label: "Neuron ID" },
  { key: "neuronText", label: "SQL Query", searchable: true },
  { key: "author", label: "Author" },
  { key: "extraction", label: "Run Count" },
  { key: "queryStartTime", label: "Run Date" },
];

// Unique options
function getUniqueOptions(key: keyof Query) {
  return Array.from(new Set(queries.value.map((q) => q[key]))).filter(Boolean).sort() as string[];
}
function getUniqueArrayOptions(key: keyof Query) {
  return Array.from(new Set(queries.value.flatMap((q) => q[key] || [])))
    .filter(Boolean)
    .sort() as string[];
}

// Helper function to get original types from mapped type
function getOriginalTypesFromMapped(mappedType: string): string[] {
  if (mappedType === "Original Query") {
    return ["MAIN"];
  } else if (mappedType === "Extracted Neuron") {
    return ["CTE", "FROM", "JOIN"];
  }
  return [];
}

// Helper function to get mapped type from original type
function getMappedTypeFromOriginal(originalType: string): string {
  return mapQueryType(originalType);
}

// Function to remove an original type
function removeOriginalType(originalTypeToRemove: string) {
  // Remove the specific original type
  selectedOriginalTypes.value = selectedOriginalTypes.value.filter(type => type !== originalTypeToRemove);
  
  // Update the mapped types based on remaining original types
  updateMappedTypesFromOriginal();
}

// Function to update mapped types based on selected original types
function updateMappedTypesFromOriginal() {
  const mappedTypes = new Set<string>();
  
  selectedOriginalTypes.value.forEach(originalType => {
    const mappedType = getMappedTypeFromOriginal(originalType);
    mappedTypes.add(mappedType);
  });
  
  filters.value.queryType = Array.from(mappedTypes);
}

// Get filter option count
function getFilterOptionCount(groupKey: string): number {
  if (groupKey === "extraction") {
    return maxExtraction.value - minExtraction.value + 1;
  } else if (groupKey === "queryType") {
    return 2; // "Extracted Neuron" and "Original Query"
  } else {
    const options = filterOptions.value[groupKey as keyof typeof filterOptions.value];
    return Array.isArray(options) ? options.length : 0;
  }
}



const filterOptions = computed(() => ({
  features: getUniqueArrayOptions("features"),
  indicationEnrichments: getUniqueArrayOptions("indicationEnrichments"),
  medicationEnrichments: getUniqueArrayOptions("medicationEnrichments"),
  tableNames: getUniqueArrayOptions("tableNames"),
  columnNames: getUniqueArrayOptions("columnNames"),
  author: getUniqueOptions("author"),
  queryType: ["Extracted Neuron", "Original Query"], // Show mapped names
}));

// Computed property to get original types as tags
const queryTypeTags = computed(() => {
  return selectedOriginalTypes.value;
});

// Run count min/max
const minExtraction = computed(() => {
  if (queries.value.length === 0) return 0;
  return Math.min(...queries.value.map((q) => q.extraction ?? 0));
});
const maxExtraction = computed(() => {
  if (queries.value.length === 0) return 100;
  return Math.max(...queries.value.map((q) => q.extraction ?? 0));
});

// Searching & sorting
function searchInObject(obj: any, text: string): boolean {
  if (!text) return true;
  const lower = text.toLowerCase();
  return Object.values(obj).some((value) => {
    if (typeof value === "string") return value.toLowerCase().includes(lower);
    if (Array.isArray(value)) return value.some((v: string) => v.toLowerCase().includes(lower));
    if (value && typeof value === "object") return searchInObject(value, text);
    return false;
  });
}

const sortState = ref<{ key: string; direction: "asc" | "desc" }>({
  key: "id",
  direction: "asc",
});
function sortBy(columnKey: string) {
  if (sortState.value.key === columnKey) {
    sortState.value.direction = sortState.value.direction === "asc" ? "desc" : "asc";
  } else {
    sortState.value.key = columnKey;
    if (columnKey === "extraction") {
      sortState.value.direction = "desc";
    } else if (columnKey === "id") {
      sortState.value.direction = "asc";
    } else {
      sortState.value.direction = "asc";
    }
  }
}
function compareQueries(a: Query, b: Query) {
  const { key, direction } = sortState.value;
  const valA = a[key as keyof Query];
  const valB = b[key as keyof Query];

  if (key === "id") {
    // Sort by ID as string, but handle numeric parts properly
    const aStr = String(valA || "");
    const bStr = String(valB || "");
    return direction === "asc"
      ? aStr.localeCompare(bStr, undefined, { numeric: true })
      : bStr.localeCompare(aStr, undefined, { numeric: true });
  } else if (key === "neuronId") {
    // Extract numbers after AST_ for comparison
    const numA = parseInt((String(valA).split('AST_')[1] || '0'), 10);
    const numB = parseInt((String(valB).split('AST_')[1] || '0'), 10);
    return direction === "asc" ? numA - numB : numB - numA;
  } else if (key === "extraction") {
    const numA = Number(valA ?? 0);
    const numB = Number(valB ?? 0);
    return direction === "asc" ? numA - numB : numB - numA;
  } else {
    const sA = String(valA ?? "");
    const sB = String(valB ?? "");
    const cmp = sA.localeCompare(sB);
    return direction === "asc" ? cmp : -cmp;
  }
}

function applyFilters() {
  isLoading.value = true;
  
  try {
    const results = queries.value.filter((q) => {
      const textMatch = searchInObject(q, heroSearchTerm.value);

      // Handle author filter
      const authorMatch = filters.value.author.length === 0 || 
        filters.value.author.includes(q.author);

      // Handle query type filter
      const queryTypeMatch = selectedOriginalTypes.value.length === 0 || 
        selectedOriginalTypes.value.includes(q.componentType);

      // Handle everything else
      const otherFiltersMatch = Object.entries(filters.value)
        .filter(([k]) => k !== "author" && k !== "queryType")
        .every(([key, values]) => {
          if (!values || values.length === 0) return true;
          if (key === "extraction") {
            const [minVal, maxVal] = filters.value.extraction;
            const numericVal = q.extraction ?? 0;
            return numericVal >= minVal && numericVal <= maxVal;
          } else {
            const filterValues = values as string[];
            const queryValue = q[key as keyof Query];
            if (Array.isArray(queryValue)) {
              return filterValues.some((v) => queryValue.map(String).includes(v));
            } else {
              return filterValues.includes(String(queryValue));
            }
          }
        });

      return textMatch && authorMatch && queryTypeMatch && otherFiltersMatch;
    });

    // Apply unique filter if enabled
    if (showUniqueQueries.value) {
      const uniqueMap = new Map();
      results.forEach((query) => {
        if (!uniqueMap.has(query.neuronId)) {
          uniqueMap.set(query.neuronId, query);
        }
      });
      filteredQueries.value = Array.from(uniqueMap.values());
    } else {
      filteredQueries.value = results;
    }
    
    // Sort the filtered results
    filteredQueries.value.sort(compareQueries);
    
    // Reset to first page when filters change
    currentPage.value = 1;
    updateDisplayedQueries();
  } catch (error) {
    console.error('Error in applyFilters:', error);
    // Fallback: show all queries if filtering fails
    filteredQueries.value = queries.value;
    currentPage.value = 1;
    updateDisplayedQueries();
  } finally {
    isLoading.value = false;
  }
}

// Range slider updates
function updateMinExtraction(e: Event) {
  const val = parseInt((e.target as HTMLInputElement).value, 10);
  filters.value.extraction[0] = val;
  if (val > filters.value.extraction[1]) {
    filters.value.extraction[1] = val;
  }
}
function updateMaxExtraction(e: Event) {
  const val = parseInt((e.target as HTMLInputElement).value, 10);
  filters.value.extraction[1] = val;
  if (val < filters.value.extraction[0]) {
    filters.value.extraction[0] = val;
  }
}

// Input field updates
function updateMinExtractionFromInput(e: Event) {
  const val = parseInt((e.target as HTMLInputElement).value, 10);
  if (isNaN(val)) return;
  
  const minVal = Math.max(minExtraction.value, val);
  const maxVal = Math.min(maxExtraction.value, val);
  
  filters.value.extraction[0] = minVal;
  if (minVal > filters.value.extraction[1]) {
    filters.value.extraction[1] = minVal;
  }
}

function updateMaxExtractionFromInput(e: Event) {
  const val = parseInt((e.target as HTMLInputElement).value, 10);
  if (isNaN(val)) return;
  
  const minVal = Math.max(minExtraction.value, val);
  const maxVal = Math.min(maxExtraction.value, val);
  
  filters.value.extraction[1] = maxVal;
  if (maxVal < filters.value.extraction[0]) {
    filters.value.extraction[0] = maxVal;
  }
}

// Reset extraction range to full range
function resetExtractionRange() {
  filters.value.extraction = [minExtraction.value, maxExtraction.value];
}

// Expand/collapse
function toggleSection(section: OpenSectionKey) {
  openSections.value[section] = !openSections.value[section];
}
function expandAll() {
  (Object.keys(openSections.value) as OpenSectionKey[]).forEach((key) => {
    openSections.value[key] = true;
  });
}
function collapseAll() {
  (Object.keys(openSections.value) as OpenSectionKey[]).forEach((key) => {
    openSections.value[key] = false;
  });
}

// Dropdown
function toggleDropdown(groupKey: string) {
  dropdownStates.value[groupKey] = !dropdownStates.value[groupKey];
}

function handleDropdownSearch(groupKey: string) {
  // This function handles the input event for dropdown search
  // The actual filtering is handled by the filteredOptions function
  // We can add additional logic here if needed
}

function filteredOptions(groupKey: string) {
  const options = filterOptions.value[groupKey as keyof typeof filterOptions.value] || [];
  const searchTerm = dropdownSearch.value[groupKey]?.toLowerCase() || "";
  return options.filter((o) => o.toLowerCase().includes(searchTerm));
}

// Handle filter changes from dropdowns
function handleFilterChange(groupKey: string) {
  // Special handling for queryType
  if (groupKey === 'queryType') {
    updateOriginalTypesFromMapped();
  }
  
  // Close dropdown after selection
  setTimeout(() => {
    dropdownStates.value[groupKey] = false;
  }, 100);
}

// Function to update original types based on selected mapped types
function updateOriginalTypesFromMapped() {
  const originalTypes = new Set<string>();
  
  filters.value.queryType.forEach(mappedType => {
    const types = getOriginalTypesFromMapped(mappedType);
    types.forEach(type => originalTypes.add(type));
  });
  
  selectedOriginalTypes.value = Array.from(originalTypes);
}

// Clear filters
function clearFilterGroup(groupKey: string) {
  if (groupKey === "extraction") {
    filters.value.extraction = [minExtraction.value, maxExtraction.value];
  } else if (groupKey === "queryType") {
    filters.value.queryType = [];
    selectedOriginalTypes.value = [];
    dropdownSearch.value[groupKey] = "";
  } else {
    filters.value[groupKey as keyof typeof filters.value] = [];
    dropdownSearch.value[groupKey] = "";
  }
}
function clearAllFilters() {
  Object.keys(filters.value).forEach((k) => {
    if (k === "extraction") {
      filters.value.extraction = [minExtraction.value, maxExtraction.value];
    } else {
      filters.value[k as keyof typeof filters.value] = [];
    }
  });
  selectedOriginalTypes.value = []; // Clear original types
  Object.keys(dropdownSearch.value).forEach((k) => {
    dropdownSearch.value[k] = "";
  });
  heroSearchTerm.value = "";
  
  // Clear from localStorage as well
  clearFiltersFromStorage();
}

// Filter persistence functions
function saveCurrentFilters() {
  const filterState: FilterState = {
    searchTerm: heroSearchTerm.value,
    selectedFeatures: filters.value.features,
    selectedTags: [], // Not used in this view
    selectedAuthors: filters.value.author,
    selectedQueryTypes: selectedOriginalTypes.value,
    selectedTables: filters.value.tableNames,
    selectedColumns: filters.value.columnNames,
    selectedIndicationEnrichments: filters.value.indicationEnrichments,
    selectedMedicationEnrichments: filters.value.medicationEnrichments,
    extractionRange: filters.value.extraction as [number, number],
    isExtractionRangeSet: filters.value.extraction[0] !== 0 || filters.value.extraction[1] !== 0,
    showUniqueQueries: showUniqueQueries.value,
  };
  saveFiltersToStorage(filterState);
}

function loadPersistedFilters() {
  const persisted = loadFiltersFromStorage();
  if (persisted) {
    if (persisted.searchTerm) heroSearchTerm.value = persisted.searchTerm;
    if (persisted.selectedFeatures) filters.value.features = persisted.selectedFeatures;
    if (persisted.selectedAuthors) filters.value.author = persisted.selectedAuthors;
    if (persisted.selectedQueryTypes) selectedOriginalTypes.value = persisted.selectedQueryTypes;
    if (persisted.selectedTables) filters.value.tableNames = persisted.selectedTables;
    if (persisted.selectedColumns) filters.value.columnNames = persisted.selectedColumns;
    if (persisted.selectedIndicationEnrichments) filters.value.indicationEnrichments = persisted.selectedIndicationEnrichments;
    if (persisted.selectedMedicationEnrichments) filters.value.medicationEnrichments = persisted.selectedMedicationEnrichments;
    if (persisted.extractionRange) filters.value.extraction = persisted.extractionRange;
    if (persisted.showUniqueQueries !== undefined) showUniqueQueries.value = persisted.showUniqueQueries;
  }
}

// Navigation
function goToDetails(queryId: string) {
  // Navigate to query details in the same tab
  router.push(`/query/${queryId}`);
}
function handleHeroSearch(term: string) {
  console.log('Hero search received:', term);
  heroSearchTerm.value = term;
  currentPage.value = 1;
  applyFilters();
}

function handleQuerySelect(query: Query) {
  // Navigate to the query details page
  goToDetails(query.id);
}

// Handle page change
function handlePageChange(page: number) {
  currentPage.value = page;
  updateDisplayedQueries();
}

// Add function to update displayed queries
function updateDisplayedQueries() {
  const startIndex = (currentPage.value - 1) * itemsPerPage;
  const endIndex = startIndex + itemsPerPage;
  displayedQueries.value = filteredQueries.value.slice(startIndex, endIndex);
}

// Add handleToggleUnique function
const handleToggleUnique = (show: boolean) => {
  showUniqueQueries.value = show;
  applyFilters();
};

// Simple debounced apply filters for dropdown interactions
let filterDebounceTimeout: number | undefined;
function debouncedApplyFilters() {
  if (filterDebounceTimeout) {
    clearTimeout(filterDebounceTimeout);
  }
  filterDebounceTimeout = window.setTimeout(() => {
    applyFilters();
  }, 150);
}

// Watch & Lifecycle
watch([heroSearchTerm, filters, sortState], () => {
  currentPage.value = 1; // Reset to first page when filters change
  applyFilters();
}, { deep: true });

// Watch for filter changes and save to localStorage
watch([heroSearchTerm, filters, showUniqueQueries, selectedOriginalTypes], () => {
  saveCurrentFilters();
}, { deep: true });

onMounted(() => {
  document.addEventListener("click", closeDropdowns);
  
  // Load persisted filters first
  loadPersistedFilters();
  
  // Set extraction range if not loaded from persistence
  if (filters.value.extraction[0] === 0 && filters.value.extraction[1] === 0) {
    filters.value.extraction = [minExtraction.value, maxExtraction.value];
  }
  
  // Set queryType section to be open by default
  openSections.value.queryType = false;
  currentPage.value = 1;
  
  // Load data immediately
  applyFilters();
});
onUnmounted(() => {
  document.removeEventListener("click", closeDropdowns);
});
function closeDropdowns(e: MouseEvent) {
  const t = e.target as HTMLElement;
  if (!t.closest(".dropdown-container")) {
    Object.keys(dropdownStates.value).forEach((k) => {
      dropdownStates.value[k] = false;
    });
  }
}

// Expose (optional)
__expose({
  filteredQueries,
  displayedQueries,
  heroSearchTerm,
  filters,
  openSections,
  dropdownStates,
  dropdownSearch,
  sortState,
  sortBy,
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(HeroSection, {
      queries: queries.value,
      onSearch: handleHeroSearch,
      onSelectQuery: handleQuerySelect
    }, null, 8, ["queries"]),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("button", {
        onClick: _cache[0] || (_cache[0] = ($event: any) => (showMobileFilters.value = !showMobileFilters.value)),
        class: "w-full flex items-center justify-center gap-2 px-4 py-3 bg-[#157813] text-white rounded-lg shadow-lg transition-transform hover:scale-105 focus:outline-none"
      }, [...(_cache[7] || (_cache[7] = [
        _createElementVNode("svg", {
          xmlns: "http://www.w3.org/2000/svg",
          class: "h-5 w-5",
          viewBox: "0 0 20 20",
          fill: "#ffffff"
        }, [
          _createElementVNode("path", {
            "fill-rule": "evenodd",
            d: "M3 3a1 1 0 011-1h12a1 1 0 011 1v3a1 1 0 01-.293.707L12 11.414V15a1 1 0 01-.293.707l-2 2A1 1 0 018 17v-5.586L3.293 6.707A1 1 0 \n            013 6V3z",
            "clip-rule": "evenodd"
          })
        ], -1),
        _createTextVNode(" Filters ", -1)
      ]))])
    ]),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("aside", {
          class: _normalizeClass(["md:w-72 w-full flex-shrink-0 bg-gray-100 rounded-lg shadow-sm border-gray-200 p-4 md:p-5 md:mr-6", {
            'fixed inset-y-0 left-0 z-50 transform': true,
            '-translate-x-full': !showMobileFilters.value,
            'translate-x-0': showMobileFilters.value,
            'md:static md:translate-x-0': true,
          }])
        }, [
          _createElementVNode("div", _hoisted_5, [
            _cache[9] || (_cache[9] = _createElementVNode("h3", { class: "text-lg font-bold text-gray-900" }, "Filters", -1)),
            _createElementVNode("button", {
              onClick: _cache[1] || (_cache[1] = ($event: any) => (showMobileFilters.value = false)),
              class: "p-2 text-gray-500 hover:text-gray-700 focus:outline-none"
            }, [...(_cache[8] || (_cache[8] = [
              _createElementVNode("svg", {
                xmlns: "http://www.w3.org/2000/svg",
                class: "h-6 w-6",
                fill: "none",
                viewBox: "0 0 24 24",
                stroke: "currentColor"
              }, [
                _createElementVNode("path", {
                  "stroke-linecap": "round",
                  "stroke-linejoin": "round",
                  "stroke-width": "2",
                  d: "M6 18L18 6M6 6l12 12"
                })
              ], -1)
            ]))])
          ]),
          _createElementVNode("div", { class: "flex justify-between items-center mb-4" }, [
            _cache[11] || (_cache[11] = _createElementVNode("h3", { class: "font-semibold text-gray-900 text-2xl" }, "Filters", -1)),
            _createElementVNode("div", { class: "flex items-center gap-2 mx-2" }, [
              _createElementVNode("button", {
                onClick: collapseAll,
                class: "text-sm text-[#157813] hover:text-[#46cc44]",
                title: "Collapse all"
              }, " ▲ "),
              _createElementVNode("button", {
                onClick: expandAll,
                class: "text-sm text-[#157813] hover:text-[#46cc44]",
                title: "Expand all"
              }, " ▼ "),
              _createElementVNode("button", {
                onClick: clearAllFilters,
                class: "text-sm text-[#157813] hover:text-[#46cc44] font-medium flex items-center gap-1 whitespace-nowrap"
              }, [...(_cache[10] || (_cache[10] = [
                _createElementVNode("svg", {
                  xmlns: "http://www.w3.org/2000/svg",
                  class: "h-4 w-4",
                  viewBox: "0 0 20 20",
                  fill: "currentColor"
                }, [
                  _createElementVNode("path", {
                    "fill-rule": "evenodd",
                    d: "M9 2a1 1 0 00-.894.553L7.382 4H4a1 1 0 \n                    000 2v10a2 2 0 002 2h8a2 2 0 \n                    002-2V6a1 1 0 100-2h-3.382l-.724-1.447A1 1 0 \n                    0011 2H9zM7 8a1 1 0 \n                    012 0v6a1 1 0 \n                    11-2 0V8zm5-1a1 1 0 \n                    00-1 1v6a1 1 0 \n                    102 0V8a1 1 0 00-1-1z",
                    "clip-rule": "evenodd"
                  })
                ], -1),
                _createTextVNode(" Clear All ", -1)
              ]))])
            ])
          ]),
          _createElementVNode("div", null, [
            (_openBlock(), _createElementBlock(_Fragment, null, _renderList(filterGroups, (groupLabel, groupKey) => {
              return _createElementVNode("div", {
                key: groupKey,
                class: "border-b border-gray-200 pb-5 mb-2"
              }, [
                _createElementVNode("div", {
                  class: "flex justify-between items-center cursor-pointer hover:bg-gray-50 hover:rounded-md p-2 -m-2 transition-colors duration-200",
                  onClick: ($event: any) => (toggleSection(groupKey))
                }, [
                  _createElementVNode("h4", _hoisted_7, [
                    _createTextVNode(_toDisplayString(groupLabel) + " ", 1),
                    (groupKey !== 'extraction' && getFilterOptionCount(groupKey) > 0)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_8, " (" + _toDisplayString(getFilterOptionCount(groupKey)) + ") ", 1))
                      : _createCommentVNode("", true),
                    (groupKey !== 'extraction' && filters.value[groupKey] && filters.value[groupKey].length > 0)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_9, " (" + _toDisplayString(filters.value[groupKey].length) + ") ", 1))
                      : _createCommentVNode("", true)
                  ]),
                  _createElementVNode("span", _hoisted_10, _toDisplayString(openSections.value[groupKey] ? "▼" : "▶"), 1)
                ], 8, _hoisted_6),
                _withDirectives(_createElementVNode("div", _hoisted_11, [
                  _createElementVNode("div", _hoisted_12, [
                    _createElementVNode("button", {
                      onClick: _withModifiers(($event: any) => (clearFilterGroup(groupKey)), ["stop"]),
                      class: "text-xs text-[#157813] hover:text-[#46cc44] flex items-center gap-1"
                    }, [...(_cache[12] || (_cache[12] = [
                      _createElementVNode("svg", {
                        xmlns: "http://www.w3.org/2000/svg",
                        class: "h-3 w-3",
                        viewBox: "0 0 20 20",
                        fill: "currentColor"
                      }, [
                        _createElementVNode("path", {
                          "fill-rule": "evenodd",
                          d: "M4.293 4.293a1 1 0 \n                            011.414 0L10 8.586l4.293-4.293a1 1 0 \n                            111.414 1.414L11.414 10l4.293 4.293a1 1 0 \n                            01-1.414 1.414L10 11.414l-4.293 4.293\n                            a1 1 0 01-1.414-1.414L8.586 10 \n                            4.293 5.707a1 1 0 010-1.414z",
                          "clip-rule": "evenodd"
                        })
                      ], -1),
                      _createTextVNode(" Clear ", -1)
                    ]))], 8, _hoisted_13)
                  ]),
                  (groupKey === 'extraction')
                    ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
                        _createElementVNode("div", _hoisted_15, [
                          (filtersLoading.value || typeof minExtraction.value !== 'number' || typeof maxExtraction.value !== 'number' || minExtraction.value === maxExtraction.value)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_16, [...(_cache[13] || (_cache[13] = [
                                _createElementVNode("div", { class: "animate-spin rounded-full h-6 w-6 border-b-2 border-[#157813]" }, null, -1),
                                _createElementVNode("span", { class: "ml-2 text-gray-600" }, "Loading...", -1)
                              ]))]))
                            : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                _createElementVNode("div", _hoisted_17, [
                                  _cache[14] || (_cache[14] = _createElementVNode("div", { class: "text-sm font-medium text-gray-900 mb-1" }, " Run Count Range ", -1)),
                                  _createElementVNode("div", _hoisted_18, " Available: " + _toDisplayString(minExtraction.value) + " - " + _toDisplayString(maxExtraction.value) + " runs ", 1)
                                ]),
                                _createElementVNode("div", _hoisted_19, [
                                  _createElementVNode("div", null, [
                                    _cache[15] || (_cache[15] = _createElementVNode("label", { class: "block text-xs font-medium text-gray-700 mb-1" }, "Min Runs", -1)),
                                    _createElementVNode("input", {
                                      type: "number",
                                      min: minExtraction.value,
                                      max: maxExtraction.value,
                                      value: filters.value.extraction[0],
                                      onInput: _cache[2] || (_cache[2] = ($event: any) => (updateMinExtractionFromInput($event))),
                                      class: "w-full px-2 py-1 text-sm border border-gray-300 rounded focus:outline-none focus:border-[#157813] focus:ring-1 focus:ring-[#157813]",
                                      placeholder: "Min"
                                    }, null, 40, _hoisted_20)
                                  ]),
                                  _createElementVNode("div", null, [
                                    _cache[16] || (_cache[16] = _createElementVNode("label", { class: "block text-xs font-medium text-gray-700 mb-1" }, "Max Runs", -1)),
                                    _createElementVNode("input", {
                                      type: "number",
                                      min: minExtraction.value,
                                      max: maxExtraction.value,
                                      value: filters.value.extraction[1],
                                      onInput: _cache[3] || (_cache[3] = ($event: any) => (updateMaxExtractionFromInput($event))),
                                      class: "w-full px-2 py-1 text-sm border border-gray-300 rounded focus:outline-none focus:border-[#157813] focus:ring-1 focus:ring-[#157813]",
                                      placeholder: "Max"
                                    }, null, 40, _hoisted_21)
                                  ])
                                ]),
                                _createElementVNode("div", _hoisted_22, [
                                  _createElementVNode("span", _hoisted_23, [
                                    _cache[17] || (_cache[17] = _createTextVNode(" Selected: ", -1)),
                                    _createElementVNode("span", _hoisted_24, _toDisplayString(filters.value.extraction[0]), 1),
                                    _cache[18] || (_cache[18] = _createTextVNode(" - ", -1)),
                                    _createElementVNode("span", _hoisted_25, _toDisplayString(filters.value.extraction[1]), 1),
                                    _cache[19] || (_cache[19] = _createTextVNode(" runs ", -1))
                                  ])
                                ]),
                                _createElementVNode("div", _hoisted_26, [
                                  _cache[21] || (_cache[21] = _createElementVNode("div", { class: "text-xs text-gray-600 text-center" }, "Drag to adjust range", -1)),
                                  _createElementVNode("div", _hoisted_27, [
                                    _cache[20] || (_cache[20] = _createElementVNode("div", { class: "slider-track" }, null, -1)),
                                    _createElementVNode("div", {
                                      class: "slider-range",
                                      style: _normalizeStyle({
                                left: `${((filters.value.extraction[0] - minExtraction.value) / (maxExtraction.value - minExtraction.value)) * 100}%`,
                                width: `${((filters.value.extraction[1] - filters.value.extraction[0]) / (maxExtraction.value - minExtraction.value)) * 100}%`
                              })
                                    }, null, 4),
                                    _createElementVNode("input", {
                                      type: "range",
                                      class: "slider-thumb slider-thumb-min",
                                      min: minExtraction.value,
                                      max: maxExtraction.value,
                                      step: "1",
                                      value: filters.value.extraction[0],
                                      onInput: _cache[4] || (_cache[4] = ($event: any) => (updateMinExtraction($event))),
                                      title: "Minimum run count"
                                    }, null, 40, _hoisted_28),
                                    _createElementVNode("input", {
                                      type: "range",
                                      class: "slider-thumb slider-thumb-max",
                                      min: minExtraction.value,
                                      max: maxExtraction.value,
                                      step: "1",
                                      value: filters.value.extraction[1],
                                      onInput: _cache[5] || (_cache[5] = ($event: any) => (updateMaxExtraction($event))),
                                      title: "Maximum run count"
                                    }, null, 40, _hoisted_29)
                                  ]),
                                  _createElementVNode("div", _hoisted_30, [
                                    _createElementVNode("span", null, _toDisplayString(minExtraction.value), 1),
                                    _createElementVNode("span", null, _toDisplayString(maxExtraction.value), 1)
                                  ])
                                ]),
                                _createElementVNode("div", { class: "text-center" }, [
                                  _createElementVNode("button", {
                                    onClick: resetExtractionRange,
                                    class: "text-xs text-[#157813] hover:text-[#46cc44] underline"
                                  }, " Reset to full range ")
                                ])
                              ], 64))
                        ])
                      ]))
                    : (_openBlock(), _createElementBlock("div", _hoisted_31, [
                        _createElementVNode("div", _hoisted_32, [
                          _createElementVNode("div", {
                            class: "dropdown-container cursor-pointer bg-white border border-gray-300 rounded-md p-3 text-sm flex items-center justify-between hover:border-green-500 hover:shadow-sm transition-all duration-200",
                            onClick: _withModifiers(($event: any) => (toggleDropdown(groupKey)), ["stop"])
                          }, [
                            _createElementVNode("div", _hoisted_34, [
                              (groupKey === 'queryType')
                                ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(queryTypeTags.value, (originalType) => {
                                    return (_openBlock(), _createElementBlock("span", {
                                      key: originalType,
                                      class: "bg-[#157813] text-white px-2 py-1 rounded-full text-xs flex items-center gap-1"
                                    }, [
                                      _createTextVNode(_toDisplayString(originalType) + " ", 1),
                                      _createElementVNode("button", {
                                        onClick: _withModifiers(($event: any) => (removeOriginalType(originalType)), ["stop"]),
                                        class: "hover:text-emerald-200"
                                      }, " × ", 8, _hoisted_35)
                                    ]))
                                  }), 128))
                                : (_openBlock(true), _createElementBlock(_Fragment, { key: 1 }, _renderList(filters.value[groupKey], (selected) => {
                                    return (_openBlock(), _createElementBlock("span", {
                                      key: selected,
                                      class: "bg-[#157813] text-white px-2 py-1 rounded-full text-xs flex items-center gap-1"
                                    }, [
                                      _createTextVNode(_toDisplayString(selected) + " ", 1),
                                      _createElementVNode("button", {
                                        onClick: _withModifiers(($event: any) => (
                                  filters.value[groupKey] = filters.value[groupKey].filter((f) => f !== selected)
                                ), ["stop"]),
                                        class: "hover:text-emerald-200"
                                      }, " × ", 8, _hoisted_36)
                                    ]))
                                  }), 128)),
                              ((groupKey === 'queryType' ? queryTypeTags.value.length === 0 : filters.value[groupKey].length === 0))
                                ? _withDirectives((_openBlock(), _createElementBlock("input", {
                                    key: 2,
                                    type: "text",
                                    placeholder: "Type to search fields...",
                                    class: "w-full outline-none bg-transparent placeholder-gray-400 text-gray-700",
                                    onInput: ($event: any) => (handleDropdownSearch(groupKey)),
                                    onFocus: ($event: any) => (toggleDropdown(groupKey)),
                                    "onUpdate:modelValue": ($event: any) => ((dropdownSearch.value[groupKey]) = $event)
                                  }, null, 40, _hoisted_37)), [
                                    [_vModelText, dropdownSearch.value[groupKey]]
                                  ])
                                : _createCommentVNode("", true)
                            ]),
                            _cache[22] || (_cache[22] = _createElementVNode("svg", {
                              xmlns: "http://www.w3.org/2000/svg",
                              class: "h-4 w-4 text-green-600 ml-2",
                              fill: "none",
                              viewBox: "0 0 24 24",
                              stroke: "currentColor"
                            }, [
                              _createElementVNode("path", {
                                "stroke-linecap": "round",
                                "stroke-linejoin": "round",
                                "stroke-width": "2",
                                d: "M19 9l-7 7-7-7"
                              })
                            ], -1))
                          ], 8, _hoisted_33),
                          _withDirectives(_createElementVNode("div", _hoisted_38, [
                            _createElementVNode("div", {
                              class: "p-2",
                              onClick: _cache[6] || (_cache[6] = _withModifiers(() => {}, ["stop"]))
                            }, [
                              _createElementVNode("div", _hoisted_39, [
                                _withDirectives(_createElementVNode("input", {
                                  type: "text",
                                  placeholder: "Search...",
                                  class: "w-full pl-8 pr-2 py-1 border-b border-gray-200 focus:outline-none focus:border-[#46cc44]",
                                  "onUpdate:modelValue": ($event: any) => ((dropdownSearch.value[groupKey]) = $event),
                                  onKeydown: _withKeys(($event: any) => (dropdownStates.value[groupKey] = false), ["esc"])
                                }, null, 40, _hoisted_40), [
                                  [_vModelText, dropdownSearch.value[groupKey]]
                                ]),
                                _cache[23] || (_cache[23] = _createElementVNode("svg", {
                                  xmlns: "http://www.w3.org/2000/svg",
                                  class: "h-4 w-4 absolute left-2 top-2 text-gray-400",
                                  fill: "none",
                                  viewBox: "0 0 24 24",
                                  stroke: "currentColor"
                                }, [
                                  _createElementVNode("path", {
                                    "stroke-linecap": "round",
                                    "stroke-linejoin": "round",
                                    "stroke-width": "2",
                                    d: "M21 21l-6-6m2-5a7 7 0 \n                                  11-14 0 7 7 0 0114 0z"
                                  })
                                ], -1))
                              ]),
                              _createElementVNode("div", _hoisted_41, [
                                (filteredOptions(groupKey).length === 0)
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_42, " No options available "))
                                  : (_openBlock(true), _createElementBlock(_Fragment, { key: 1 }, _renderList(filteredOptions(groupKey), (option) => {
                                      return (_openBlock(), _createElementBlock("label", {
                                        key: option,
                                        class: "flex items-center px-2 py-1 hover:bg-green-50 hover:text-green-700 cursor-pointer rounded transition-colors duration-150"
                                      }, [
                                        _withDirectives(_createElementVNode("input", {
                                          type: "checkbox",
                                          value: option,
                                          "onUpdate:modelValue": ($event: any) => ((filters.value[groupKey]) = $event),
                                          class: "mr-2 rounded border-gray-300",
                                          style: {"accent-color":"#157813"},
                                          onChange: ($event: any) => (handleFilterChange(groupKey))
                                        }, null, 40, _hoisted_43), [
                                          [_vModelCheckbox, filters.value[groupKey]]
                                        ]),
                                        _createElementVNode("span", _hoisted_44, _toDisplayString(option), 1)
                                      ]))
                                    }), 128))
                              ])
                            ])
                          ], 512), [
                            [_vShow, dropdownStates.value[groupKey]]
                          ])
                        ])
                      ]))
                ], 512), [
                  [_vShow, openSections.value[groupKey]]
                ])
              ])
            }), 64))
          ])
        ], 2),
        _createElementVNode("main", _hoisted_45, [
          (isLoading.value)
            ? (_openBlock(), _createElementBlock("div", _hoisted_46, [
                _createVNode(LoadingIndicator, {
                  title: "Filtering queries...",
                  subtitle: "Applying your search criteria",
                  status: "Processing filters",
                  duration: 500,
                  "auto-progress": true
                })
              ]))
            : (_openBlock(), _createElementBlock("div", _hoisted_47, [
                _createElementVNode("div", _hoisted_48, " Showing " + _toDisplayString(displayedQueries.value.length) + " of " + _toDisplayString(filteredQueries.value.length) + " results ", 1),
                _createElementVNode("div", _hoisted_49, [
                  _createVNode(QueryTable, {
                    queries: displayedQueries.value,
                    headers: tableHeaders,
                    "sort-state": sortState.value,
                    onSort: sortBy,
                    onRowClick: goToDetails,
                    onToggleUnique: handleToggleUnique
                  }, null, 8, ["queries", "sort-state"])
                ])
              ])),
          (filteredQueries.value.length > itemsPerPage)
            ? (_openBlock(), _createElementBlock("div", _hoisted_50, [
                _createVNode(Pagination, {
                  "current-page": currentPage.value,
                  "total-items": filteredQueries.value.length,
                  "items-per-page": itemsPerPage,
                  onPageChange: handlePageChange
                }, null, 8, ["current-page", "total-items"])
              ]))
            : _createCommentVNode("", true),
          (!isLoading.value && displayedQueries.value.length === 0)
            ? (_openBlock(), _createElementBlock("div", _hoisted_51, [...(_cache[24] || (_cache[24] = [
                _createElementVNode("svg", {
                  class: "mx-auto h-12 w-12 text-gray-400",
                  fill: "none",
                  viewBox: "0 0 24 24",
                  stroke: "currentColor"
                }, [
                  _createElementVNode("path", {
                    "stroke-linecap": "round",
                    "stroke-linejoin": "round",
                    "stroke-width": "2",
                    d: "M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 \n                  11-18 0 9 9 0 0118 0z"
                  })
                ], -1),
                _createElementVNode("p", { class: "mt-4" }, "No queries found matching your criteria", -1)
              ]))]))
            : _createCommentVNode("", true)
        ])
      ])
    ])
  ]))
}
}

})